module.exports = __webpack_public_path__ + "static/media/prev.d6a0ee1f.png";